import React, { memo } from 'react';
import { useMutation, useQueryCache } from 'react-query';
import { DevicesAPI } from 'api/DevicesAPI';
import { Content } from 'common/StyledComponents';
import { Layout, message } from 'antd';
import { FormikOnSubmit } from 'lib/formik.utils';
import { QueryKey } from 'api/queryKey';
import {
  RegisterNewDeviceForm,
  RegisterNewDeviceFormModel,
} from 'pages/SuperAdminModule/DevicesManagement/components/RegisterNewDeviceForm';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

export const RegisterNewDevicePage = memo(() => {
  const queryCache = useQueryCache();

  const [mutate, { isLoading }] = useMutation(DevicesAPI.registerNewDevice);

  const intlMessage = useFormatMessage();

  const handleSubmit: FormikOnSubmit<RegisterNewDeviceFormModel> = (
    formData,
    { resetForm }
  ) => {
    mutate(formData, {
      onSuccess: () => {
        queryCache.invalidateQueries(QueryKey.DevicesList).then();
        message.success(
          intlMessage(
            { id: 'devices.addNew.success' },
            { serialNumber: formData.serialNumber }
          )
        );
        resetForm();
      },
    }).then();
  };

  return (
    <Layout>
      <Content>
        <RegisterNewDeviceForm onSubmit={handleSubmit} loading={isLoading} />
      </Content>
    </Layout>
  );
});
